import React from 'react'
import BillPayDetail from 'src/app/BillPayDetail/BillPayDetail'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { billPayDetailRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

// BillPay family tabs render (exact) before this legacy :id route, so they can
// no longer fall through to it — the exceptions guard is no longer needed.
const BillPayDetailAppRoute: AppRoute = {
  id: AppLocation.BillPayDetail,
  routeProps: billPayDetailRouteProps,
  component: <BillPayDetail />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BillPayDetailAppRoute
